export default "__VITE_ASSET__60231a22__"